@if (item.template !== 'loadMore') {
  <div class="separated-search-result__wrapper">
    <div class="separated-search-result__title" [matTooltip]="item.title.length > 100 ? item.title : ''">
      <h2>{{item.title}}</h2>
    </div>
    <dl class="separated-search-result__details" [attr.aria-label]="item.title + ' details'">
      @for (detail of item.details; track detail) {
        <div class="separated-search-result__detail">
          <dt>{{detail.description}}</dt>
          <dd>{{detail.value}}</dd>
        </div>
      }
    </dl>
    <div class="separated-search-result__view-details">
      <a matButton="filled"
        class="separated-search-result__view-details-button"
        [attr.aria-label]="'View details for ' + item.title"
        [routerLink]="['/search', item.page.pageId, 'details']"
        [queryParams]="{ BsiKey: item.businessSystemItemKey }">
        <span>View Details</span>
      </a>
    </div>
  </div>
}

@if (item.template === 'loadMore') {
  <button class="separated-search-result__load-more" matButton="filled" type="button" (click)="loadMore.emit()">
    Show More Results
  </button>
}
